module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_80_90.bdb12e7c.png";